import * as FIELD_NAME from 'constant/form-item-names'

const CATEGORY = 'category'
const CATEGORY_UUID = 'category_uuid'
const SUB_CATEGORY = 'sub_category'
const ORGANISATIONS = 'organisations'
const UUID = 'uuid'
const IMAGE_NAME = 'image_name'
const USER_TYPE = 'user_type'
const USER_TYPES = 'user_types'
const ARTICLE_UUID = 'article_uuid'
const FILE_NAME = 'file_name'

const SITE_ADMIN = 'site_admin_uuid'
const SITE_COLOUR = 'site_primary_colour'
const SITE_FAVICON = 'site_favicon'
const SITE_LOGO = 'site_logo'
const SITE_NAME = 'site_name'
const SITE_UUID = 'site_uuid'
const SITE = 'site'
const SITE_LANDING_PAGE_URL = 'site_landing_page_url'

const defaultValue = (value) => value
const mapUuids = (values) => values.map((value) => value.uuid)
const extractUuid = ({ uuid }) => uuid

export default {
  [FIELD_NAME.AGENCY]: {
    field: FIELD_NAME.AGENCY,
    value: defaultValue
  },
  [FIELD_NAME.SHORT_DESCRIPTION]: {
    field: FIELD_NAME.SHORT_DESCRIPTION,
    value: defaultValue
  },
  [FIELD_NAME.PUBLISHED]: {
    field: FIELD_NAME.PUBLISHED,
    value: defaultValue
  },
  [FIELD_NAME.NAME]: {
    field: FIELD_NAME.NAME,
    value: defaultValue
  },
  [FIELD_NAME.INTRODUCTION]: {
    field: FIELD_NAME.INTRODUCTION,
    value: defaultValue
  },
  [FIELD_NAME.TITLE]: {
    field: FIELD_NAME.TITLE,
    value: defaultValue
  },
  [FIELD_NAME.ASSOCIATED_DATASET]: {
    field: FIELD_NAME.ASSOCIATED_DATASET,
    value: extractUuid
  },
  [FIELD_NAME.AUTHOR]: {
    field: FIELD_NAME.AUTHOR,
    value: extractUuid
  },
  [FIELD_NAME.QLIK_FILTER_URL]: {
    field: FIELD_NAME.QLIK_FILTER_URL,
    value: defaultValue
  },
  [FIELD_NAME.UPDATE_FREQUENCY]: {
    field: FIELD_NAME.UPDATE_FREQUENCY,
    value: defaultValue
  },
  [FIELD_NAME.QLIK_URL]: {
    field: FIELD_NAME.QLIK_URL,
    value: defaultValue
  },
  [FIELD_NAME.EMAIL]: {
    field: FIELD_NAME.EMAIL,
    value: defaultValue
  },
  [FIELD_NAME.FIRST_NAME]: {
    field: FIELD_NAME.FIRST_NAME,
    value: defaultValue
  },
  [FIELD_NAME.LAST_NAME]: {
    field: FIELD_NAME.LAST_NAME,
    value: defaultValue
  },
  [ARTICLE_UUID]: {
    field: FIELD_NAME.CATEGORY_UUID,
    value: defaultValue
  },
  [CATEGORY]: {
    field: FIELD_NAME.ARTICLE_UUID,
    value: mapUuids
  },
  [CATEGORY_UUID]: {
    field: FIELD_NAME.CATEGORY_UUID,
    value: defaultValue
  },
  [FILE_NAME]: {
    field: FIELD_NAME.FILE_NAME,
    value: defaultValue
  },
  [IMAGE_NAME]: {
    field: IMAGE_NAME,
    value: defaultValue
  },
  [ORGANISATIONS]: {
    field: FIELD_NAME.ORGANISATION_UUIDS,
    value: mapUuids
  },
  [SITE]: {
    field: SITE,
    value: defaultValue
  },
  [SITE_ADMIN]: {
    field: SITE_ADMIN,
    value: defaultValue
  },
  [SITE_COLOUR]: {
    field: SITE_COLOUR,
    value: defaultValue
  },
  [SITE_FAVICON]: {
    field: SITE_FAVICON,
    value: defaultValue
  },
  [SITE_LANDING_PAGE_URL]: {
    field: SITE_LANDING_PAGE_URL,
    value: defaultValue
  },
  [SITE_LOGO]: {
    field: SITE_LOGO,
    value: defaultValue
  },
  [SITE_NAME]: {
    field: SITE_NAME,
    value: defaultValue
  },
  [SITE_UUID]: {
    field: SITE_UUID,
    value: defaultValue
  },
  [SUB_CATEGORY]: {
    field: FIELD_NAME.SUB_CATEGORY_UUID,
    value: extractUuid
  },
  [USER_TYPE]: {
    field: FIELD_NAME.USER_TYPE_UUID,
    value: extractUuid
  },
  [USER_TYPES]: {
    field: FIELD_NAME.USER_TYPE_UUIDS,
    value: mapUuids
  },
  [UUID]: {
    field: UUID,
    value: defaultValue
  }
}
